import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import * as SentryModule from './modules/sentry.module';
import { AppComponent } from './app/app.component';

SentryModule.initSentry();

ModuleRegistry.registerModules([AllCommunityModule]);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
